/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';
import type { IPersonPhoto } from './person-photo-schema';
import { personPhotoSchema } from './person-photo-schema';

export const personPhotoResponseSchema = createApiResponseSchema(
  personPhotoSchema,
) as import('zod').ZodSchema<IAPI<IPersonPhoto>>;

export type IPersonPhotoResponse = IAPI<IPersonPhoto>;
